import a from "react";
import { getIconColor as l } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const m = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: o, color: c, withColor: r, removeClassName: t, disableSSR: d, style: i, ...p }) => {
  const g = i ? { ...m, ...i } : m;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-xianhuomadinggeer", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-ç°è´§é©¬ä¸æ ¼å°"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: r ? l(c, 0, "#262933") : "#262933",
        datafollowfill: r ? l(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M13.158 5.814a.845.845 0 0 0-.45-1.629C7.49 5.626 3.656 10.407 3.656 16.087a12.291 12.291 0 0 0 2.94 7.996 12.322 12.322 0 0 0 6.114 3.905.845.845 0 1 0 .45-1.63 10.634 10.634 0 0 1-5.277-3.37 10.601 10.601 0 0 1-2.536-6.901c0-4.9 3.307-9.03 7.812-10.273Zm6.134-1.629a.845.845 0 1 0-.45 1.63c4.506 1.243 7.813 5.372 7.813 10.271 0 4.9-3.307 9.03-7.813 10.273a.845.845 0 0 0 .45 1.628c5.219-1.44 9.053-6.221 9.053-11.9 0-5.68-3.834-10.461-9.053-11.902Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M17.15 10.21a.9.9 0 0 0-1.8 0v1.2h-.85a2.65 2.65 0 0 0 0 5.3H18a.85.85 0 0 1 0 1.7h-4.725a.9.9 0 0 0 0 1.8h2.075v1.2a.9.9 0 1 0 1.8 0v-1.2H18a2.65 2.65 0 0 0 0-5.3h-3.5a.85.85 0 1 1 0-1.7h4.725a.9.9 0 0 0 0-1.8H17.15v-1.2Z"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
